import { c as _c } from "react/compiler-runtime";
import { Divider, Stack } from '@mui/material';
import type { BackupPolicyType, Condition, Provider, ResourceType } from '@repo/api-gw-sdk';
import type { FilterProperty } from '@/types/advanceFilter';
import { ResourceSelectionDynamicEditor } from './resourceSelectionDynamicEditor';
import type { ResourcesScopeType } from './resourceSelectionDynamicViewer';
import { ResourceSelectionManualOverridesEditor } from './resourceSelectionManualEditor';
import type { ResourceSelectionState } from './resourceSelectionState';
export const ResourcesSelectionEditor = t0 => {
  const $ = _c(49);
  const {
    resourceSelection,
    setResourceSelection,
    condition,
    setCondition,
    supportedProviders,
    supportedProperties,
    supportedResourceTypes,
    conditionTitle,
    allExcludedDescription,
    allIncludedDescription,
    manualOverridesDescription,
    selectedResourceTypes,
    policyType,
    includedResources,
    excludedResources,
    setIncludedResources,
    setExcludedResources,
    resourcesScopeType,
    setResourcesScopeType
  } = t0;
  let t1;
  if ($[0] !== condition || $[1] !== excludedResources || $[2] !== includedResources || $[3] !== resourceSelection || $[4] !== resourcesScopeType) {
    t1 = resourceSelection ?? {
      condition,
      include: includedResources ?? [],
      exclude: excludedResources ?? [],
      resourcesScopeType: resourcesScopeType ?? "useConditions"
    };
    $[0] = condition;
    $[1] = excludedResources;
    $[2] = includedResources;
    $[3] = resourceSelection;
    $[4] = resourcesScopeType;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const effectiveResourceSelection = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      flexGrow: 1,
      minHeight: 0,
      gap: "100px",
      justifyContent: "space-between"
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== effectiveResourceSelection || $[8] !== setCondition || $[9] !== setResourceSelection) {
    t3 = condition_0 => {
      if (setResourceSelection) {
        setResourceSelection({
          ...effectiveResourceSelection,
          condition: condition_0
        });
      } else {
        setCondition?.(condition_0);
      }
    };
    $[7] = effectiveResourceSelection;
    $[8] = setCondition;
    $[9] = setResourceSelection;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== effectiveResourceSelection || $[12] !== setResourceSelection || $[13] !== setResourcesScopeType) {
    t4 = resourcesScopeType_0 => {
      if (setResourceSelection) {
        setResourceSelection({
          ...effectiveResourceSelection,
          resourcesScopeType: resourcesScopeType_0
        });
      } else {
        setResourcesScopeType?.(resourcesScopeType_0);
      }
    };
    $[11] = effectiveResourceSelection;
    $[12] = setResourceSelection;
    $[13] = setResourcesScopeType;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== allExcludedDescription || $[16] !== allIncludedDescription || $[17] !== conditionTitle || $[18] !== effectiveResourceSelection.condition || $[19] !== effectiveResourceSelection.resourcesScopeType || $[20] !== policyType || $[21] !== selectedResourceTypes || $[22] !== supportedProperties || $[23] !== supportedProviders || $[24] !== supportedResourceTypes || $[25] !== t3 || $[26] !== t4) {
    t5 = <ResourceSelectionDynamicEditor condition={effectiveResourceSelection.condition} setCondition={t3} supportedProviders={supportedProviders} supportedProperties={supportedProperties} supportedResourceTypes={supportedResourceTypes} conditionTitle={conditionTitle} allExcludedDescription={allExcludedDescription} allIncludedDescription={allIncludedDescription} resourcesScopeType={effectiveResourceSelection.resourcesScopeType} setResourcesScopeType={t4} selectedResourceTypes={selectedResourceTypes} policyType={policyType} />;
    $[15] = allExcludedDescription;
    $[16] = allIncludedDescription;
    $[17] = conditionTitle;
    $[18] = effectiveResourceSelection.condition;
    $[19] = effectiveResourceSelection.resourcesScopeType;
    $[20] = policyType;
    $[21] = selectedResourceTypes;
    $[22] = supportedProperties;
    $[23] = supportedProviders;
    $[24] = supportedResourceTypes;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  let t7;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      gap: "100px"
    };
    t7 = <Divider orientation="vertical" flexItem={true} />;
    $[28] = t6;
    $[29] = t7;
  } else {
    t6 = $[28];
    t7 = $[29];
  }
  let t8;
  if ($[30] !== effectiveResourceSelection || $[31] !== setIncludedResources || $[32] !== setResourceSelection) {
    t8 = include => {
      if (setResourceSelection) {
        setResourceSelection({
          ...effectiveResourceSelection,
          include
        });
      } else {
        setIncludedResources?.(include);
      }
    };
    $[30] = effectiveResourceSelection;
    $[31] = setIncludedResources;
    $[32] = setResourceSelection;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== effectiveResourceSelection || $[35] !== setExcludedResources || $[36] !== setResourceSelection) {
    t9 = exclude => {
      if (setResourceSelection) {
        setResourceSelection({
          ...effectiveResourceSelection,
          exclude
        });
      } else {
        setExcludedResources?.(exclude);
      }
    };
    $[34] = effectiveResourceSelection;
    $[35] = setExcludedResources;
    $[36] = setResourceSelection;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== effectiveResourceSelection.exclude || $[39] !== effectiveResourceSelection.include || $[40] !== manualOverridesDescription || $[41] !== supportedProviders || $[42] !== supportedResourceTypes || $[43] !== t8 || $[44] !== t9) {
    t10 = <Stack direction="row" sx={t6}>{t7}<ResourceSelectionManualOverridesEditor description={manualOverridesDescription} includeResources={effectiveResourceSelection.include} excludeResources={effectiveResourceSelection.exclude} setIncludedResources={t8} setExcludedResources={t9} supportedProviders={supportedProviders} supportedResourceTypes={supportedResourceTypes} /></Stack>;
    $[38] = effectiveResourceSelection.exclude;
    $[39] = effectiveResourceSelection.include;
    $[40] = manualOverridesDescription;
    $[41] = supportedProviders;
    $[42] = supportedResourceTypes;
    $[43] = t8;
    $[44] = t9;
    $[45] = t10;
  } else {
    t10 = $[45];
  }
  let t11;
  if ($[46] !== t10 || $[47] !== t5) {
    t11 = <Stack className="mx-[min(100px,5vw)] mt-[min(60px,3vw)]" direction="row" sx={t2}>{t5}{t10}</Stack>;
    $[46] = t10;
    $[47] = t5;
    $[48] = t11;
  } else {
    t11 = $[48];
  }
  return t11;
};